import { JOURNEY_CATEGORIES } from "./giftJourney";

const pic = (seed) => `https://picsum.photos/seed/browse-${seed}/640/420`;

/**
 * 3–4 browse tiles per occasion (visual only). Opens full-screen predefined preview.
 */
const VARIANTS = [
  { label: "Aurora", blurb: "Bold gradient frame", seed: "v0" },
  { label: "Linen", blurb: "Soft editorial layout", seed: "v1" },
  { label: "Nocturne", blurb: "Deep contrast & serif", seed: "v2" },
  { label: "Solstice", blurb: "Warm spotlight accents", seed: "v3" },
];

export function getBrowseEcardDummies(occasionSlug) {
  const slug = occasionSlug || "egift";
  return VARIANTS.slice(0, 4).map((row, i) => ({
    key: `${slug}-${i}`,
    variantIndex: i,
    title: `${row.label} · ${slug}`,
    blurb: row.blurb,
    imageurl: pic(`${slug}-${row.seed}`),
    href: `/ecard/${encodeURIComponent(slug)}?variant=${i}`,
  }));
}

export function isKnownOccasionSlug(slug) {
  return JOURNEY_CATEGORIES.some((c) => c.slug === slug);
}
